import * as React from "react";
const SvgFiRrManScientist = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-man-scientist_svg__a)">
      <path
        fill="#062147"
        d="M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m14.383 18.019-.022-.024-3.36-3.485v-2.509a1 1 0 1 0 0-2h-3a1 1 0 1 0 0 2v2.51l-3.455 3.594a2.36 2.36 0 0 0-.314 2.53 2.36 2.36 0 0 0 2.156 1.366h6.227c.956 0 1.791-.543 2.179-1.416a2.36 2.36 0 0 0-.409-2.565zm-1.419 1.753a.37.37 0 0 1-.351.229h-6.227a.37.37 0 0 1-.348-.22c-.038-.082-.083-.244 0-.349l3.462-3.598 3.406 3.534a.37.37 0 0 1 .058.404m-8.576-5.352a8 8 0 0 0-.483-.343.29.29 0 0 0-.376.063l-2.743 3.479c-.379.48-1.191.48-1.57 0l-2.76-3.499c-.077-.09-.241-.118-.36-.044a8 8 0 0 0-.786.592c-1.467 1.271-2.309 3.247-2.309 5.423V23a1 1 0 1 1-2 0v-.909c0-2.757 1.094-5.284 3-6.935q.468-.405 1.002-.755a2.294 2.294 0 0 1 3.006.458l1.992 2.525 1.975-2.504c.761-.912 2.054-1.111 3.02-.48q.32.207.618.439a1 1 0 0 1 .178 1.402.995.995 0 0 1-1.402.178z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-man-scientist_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrManScientist;
